import React, { useMemo } from 'react'
import BotaoCTA from '../../BotaoCTA'
import ReactMarkdown from 'react-markdown'
import {
  CardContainer,
  CardText,
  CardTitle,
  CardImage,
  CardBotao,
} from './styles'

const CardComImagem = ({ card }) => {
  const { titulo, descricao, imagem, botao, alinhamento, corTexto } = card

  const hasImage = useMemo(() => {
    if (!imagem) return null
    return (
      <CardImage
        src={imagem.url}
        alt={imagem.description}
        title={imagem.title}
      />
    )
  }, [imagem])

  const hasTitle = useMemo(() => {
    if (!titulo) return null
    return <CardTitle>{titulo}</CardTitle>
  }, [titulo])

  const hasDescription = useMemo(() => {
    if (!descricao) return null
    return (
      <CardText alinhamento={alinhamento} corTexto={corTexto}>
        {' '}
        <ReactMarkdown>{descricao}</ReactMarkdown>{' '}
      </CardText>
    )
  }, [alinhamento, corTexto, descricao])

  const hasButton = useMemo(() => {
    if (!botao) return null
    return (
      <CardBotao>
        <BotaoCTA botao={botao} />
      </CardBotao>
    )
  }, [botao])

  return (
    <CardContainer>
      {hasImage}
      {hasTitle}
      {hasDescription}
      {hasButton}
    </CardContainer>
  )
}

export default CardComImagem
